/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuFilterDeliveryOptions_viewer$ref = any;
export type SbRespRefineMenuFilterDeliveryOptions_viewer$ref = any;
export type SbRespRefineMenuFilterDeliveryOptions_viewer = {
    readonly " $fragmentRefs": SbSharedRefineMenuFilterDeliveryOptions_viewer$ref;
    readonly " $refType": SbRespRefineMenuFilterDeliveryOptions_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespRefineMenuFilterDeliveryOptions_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterDeliveryOptions_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '09e4498fa17facd46ea50d2acd0b82cb';
export default node;
